export default function CopyIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_6278_22292)">
        <path
          d="M6.66797 6.66699V5.00033C6.66797 3.15938 8.16035 1.66699 10.0013 1.66699L15.0013 1.66699C16.8423 1.66699 18.3346 3.15938 18.3346 5.00033V10.0003C18.3346 11.8413 16.8423 13.3337 15.0013 13.3337H13.3346M6.66797 6.66699H5.0013C3.16035 6.66699 1.66797 8.15938 1.66797 10.0003V15.0003C1.66797 16.8413 3.16035 18.3337 5.0013 18.3337H10.0013C11.8423 18.3337 13.3346 16.8413 13.3346 15.0003V13.3337M6.66797 6.66699H10.0013C11.8423 6.66699 13.3346 8.15938 13.3346 10.0003V13.3337"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6278_22292">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0 0.000488281)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
